<template>
  <div>
    <Field
      v-for="sattribute in attributes"
      :key="sattribute.name"
      :attribute="sattribute"
      :canEdit="canEdit"
      :isCopied="isCopied"
      :disabled="isCopied"
      :value="fixedValue[sattribute.name]"
      :values="fixedValue"
      @input="setSubValue(sattribute.name, $event)"
      :loading="loading"
    />
  </div>
</template>
<script>
import Field from './Field';

export default {
  props: {
    attributes: {
      required: true,
      type: Array
    },
    canEdit: {
      required: true,
      type: Boolean
    },
    isCopied: {
      required: false,
      default: false,
      type: Boolean
    },
    loading: {
      default: false,
      type: Boolean
    },
    value: {
      required: true,
      type: Object
    }
  },
  components: {
    Field
  },
  computed: {
    fixedValue() {
      return this.value || {};
    }
  },
  methods: {
    setValue(value) {
      this.$emit('input', value);
    },
    setSubValue(key, val) {
      let v = {
        ...this.fixedValue,
        [key]: val
      };
      this.setValue(v);
    }
  }
};
</script>
